var _path, _g, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopBarIconNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_439_8904",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5H24V27.5H0V3.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_439_8904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9853 22.3084V23.3955C13.9853 24.4963 13.093 25.3887 11.9922 25.3887C10.8914 25.3887 9.99902 24.4963 9.99902 23.3955V22.3084",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 19.6818C19.9995 20.6818 19.0995 21.5 17.9995 21.5H5.99951C4.89951 21.5 3.99951 20.6818 3.99951 19.6818C3.99951 18.9858 4.43551 18.3779 5.07146 18.0726C5.67571 17.7825 5.99951 17.1646 5.99951 16.5435V10.9545C5.99951 7.94209 8.68581 5.5 11.9995 5.5C15.3132 5.5 17.9995 7.94209 17.9995 10.9545V16.5435C17.9995 17.1646 18.3233 17.7825 18.9276 18.0726C19.5635 18.3779 19.9995 18.9858 19.9995 19.6818Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#EF476F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4741 3.68182V9.5H19.2809L16.9656 6.14205H16.9286V9.5H15.5224V3.68182H16.7326L19.0224 7.03409H19.0707V3.68182H20.4741Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBarIconNew);
export default __webpack_public_path__ + "static/media/topBar_Icon_new.929247c5f0c72707a15b56e29f52c6b0.svg";
export { ForwardRef as ReactComponent };